import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { AcceptWorksheetDocument, GqlError } from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'
import { castUid } from 'src/utils/brandedUid'

import { Worksheet } from '../../types'

const acceptWorksheet = async ({
  worksheetUid,
}: {
  worksheetUid: Worksheet['uid']
}): Promise<{ worksheetUid: Worksheet['uid'] }> => {
  try {
    const res = await graphqlRequest(AcceptWorksheetDocument, {
      worksheetUid,
    })
    return {
      worksheetUid: castUid<Worksheet>(res.acceptWorksheet.worksheetUid),
    }
  } catch (error) {
    throw error
  }
}

export const useAcceptWorksheet = (
  options?: UseMutationOption<{ worksheetUid: Worksheet['uid'] }, GqlError>,
) => {
  return useMutation(
    ({ worksheetUid }: { worksheetUid: Worksheet['uid'] }) =>
      acceptWorksheet({ worksheetUid }),
    options,
  )
}
